import { BehaviorSubject, Subject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import { BlocksAssetType, BlocksStylesType } from '../../model/blocks-types';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export class MultiplierControlViewModel {
  public get multiplierIcon() {
    return this.gameServices.assetCatalogueService.getAsset(BlocksAssetType.BlockMultiplier);
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get blocksLogicActionBus$() {
    return this.gameServices.gameRunnerService.blocksLogicActionBus$;
  }
  public get onGameSetupStart$() {
    return this.gameServices.gameRunnerService.onGameSetupStartTrigger;
  }
  public get onResetGameScene$() {
    return this.onResetGameScene;
  }
  public get showControl$() {
    return this.showControl.asObservable();
  }
  public get onGameSetupCompleteTrigger() {
    return this.gameServices.gameRunnerService.onGameSetupCompleteTrigger;
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }
  public get primaryLabelFill() {
    return this.gameServices.gameThemeService.getHexColor(BlocksStylesType.PrimaryLabelFill);
  }

  private readonly onResetGameScene = new Subject<void>();
  private readonly showControl = new BehaviorSubject<boolean>(false);

  constructor(private gameServices: GameServices) {}

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    scaledOffsetX: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }

  public onGameSetupStart() {
    this.showControl.next(true);
  }

  public resetGameScene() {
    this.onResetGameScene.next();
    this.showControl.next(false);
  }
}
